<template>
  <div class="animated fadeIn">
    <div v-if="!isGebrauchtwagen && dashdata && dashdata.KPI" class="row">
      <div class="col-xl">
        <div class="card">
          <div class="card-header">
            <div class="container dp-header">
              <div class="header-container">
                <div id="headtext2">{{ getKpiGroupOverallKpiName }}</div>
                <compareItem v-if="isBmwM && !(isBmwMoto || isUsedBike)"
                             id="headkpi"
                             :isCompetitionOverall="false"
                             :kpi="getKpiGroupOverallOrdered" />
                <performanceItem v-if="isBmwMoto || isUsedBike || !isBmwM"
                                 id="headkpi"
                                 :overallByWave="getOverallByWave"
                                 :kpi="getKpiGroupOverall"
                                 :isBMWMoto="isBmwMoto || isUsedBike" />
                <WideNscItem v-if="!(isBmwMoto || isUsedBike) && !isBmwM"
                             :overallByWave="getOverallByWave"
                             :kpi="getKpiGroupOverall"
                             :isBMWMoto="isBmwMoto || isUsedBike" />
              </div>
            </div>
          </div>
          <div class="card-body">
            <table class="dashtable">
              <tr>
                <td class="tdct row-pe">
                  <processexcellencecolumn v-if="!(isBmwMoto || isUsedBike) && !isBmwM && !isBmwi && !isYear(2019)"
                                           :isUsedCar="isUsedCar"
                                           :dashdata="dashdata" />
                  <processexcellencecolumnnew v-if="!(isBmwMoto || isUsedBike) && !isBmwM && isYear(2019)"
                                              :isUsedCar="isUsedCar"
                                              :selection="selection"
                                              :optionsdata="optionsdata"
                                              :dashdata="dashdata" />
                  <bmwiprocessexcellencecolumn v-if="!(isBmwMoto || isUsedBike) && !isBmwM && isBmwi && !isUsedCar && !isYear(2019)"
                                               :dashdata="dashdata" />
                  <bmwmotorradprocessexcellencecolumn v-if="(isBmwMoto || isUsedBike) && !isBmwM && !isBmwi && !isUsedCar && !MotoradOnlineSelected()"
                                                      :dashdata="dashdata"
                                                      :optionsdata="optionsdata" />
                  <bmwmotorradOnLineprocessexcellencecolumn v-if="(isBmwMoto || isUsedBike) && !isBmwM && !isBmwi && !isUsedCar && MotoradOnlineSelected()"
                                                            :dashdata="dashdata"
                                                            :optionsdata="optionsdata" />
                  <bmwmprocessexcellencecolumn v-if="isBmwM && !(isBmwMoto || isUsedBike) && !isBmwi && !isUsedCar"
                                               :dashdata="dashdata" />


                </td>
                <td class="tdct row-ct">
                  <customertreatmentcolumn v-if="!(isBmwMoto || isUsedBike) && !isBmwM && !isYear(2019)"
                                           :dashdata="dashdata"
                                           :isBmwi="isBmwi"
                                           :selectedBrand="selectedBrand" />
                  <customertreatmentcolumnnew v-if="!(isBmwMoto || isUsedBike) && !isBmwM && isYear(2019)"
                                              :dashdata="dashdata"
                                              :isBmwi="isBmwi"
                                              :selectedBrand="selectedBrand" />
                  <bmwmotorradcustomertreatmentcolumn v-if="(isBmwMoto || isUsedBike) && !isBmwM && !isBmwi && !isUsedCar"
                                                      :dashdata="dashdata" />
                  <bmwmcustomertreatmentcolumn v-if="isBmwM && !(isBmwMoto || isUsedBike) && !isBmwi && !isUsedCar"
                                               :dashdata="dashdata"
                                               :selectedBrand="selectedBrand" />
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div id="customerjourney">{{$t('Webportal.DashboardBMW.CustomerJourney')}}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="right" v-if="!isBmwM && !(isBmwMoto || isUsedBike)">&nbsp;{{ getDisclaimerText() }}</div>
      </div>
    </div>
    <div v-if="isGebrauchtwagen" class="row">
      <div class="col-xl">
        <gebrauchtwagencockpit :dashdata="dashdata"
                               :usedItems="dashdata.KPIGroup"
                               :overallData="getKpiGroupOverall" />
      </div>
    </div>
  </div>
</template>
<script>
  import CustomKpiSorting from '@/mixins/CustomKpiSorting'
  import performanceItem from './PerformanceItem'
  import compareItem from './CompareItem'
  import processexcellencecolumn from './ProcessExcellenceColumn'
  import customertreatmentcolumn from './CustomerTreatmentColumn'
  import processexcellencecolumnnew from './ProcessExcellenceColumnNew'
  import customertreatmentcolumnnew from './CustomerTreatmentColumnNew'
  import bmwmotorradOnLineprocessexcellencecolumn from './BMWMotorradOnLineProcessExcellenceColumn'
  import WideNscItem from './WideNscItem.vue'
  import bmwmotorradprocessexcellencecolumn from './BMWMotorradProcessExcellenceColumn'
  import bmwmotorradcustomertreatmentcolumn from './BMWMotorradCustomerTreatmentColumn'
  import bmwmprocessexcellencecolumn from './BMWMProcessExcellenceColumn'
  import bmwmcustomertreatmentcolumn from './BMWMCustomerTreatmentColumn'
  import bmwiprocessexcellencecolumn from './BMWiProcessExcellenceColumn'
  import gebrauchtwagencockpit from './GebrauchtwagenCockpit'
  import BrandMixin from '@/mixins/BrandMixin';

  export default {
    name: 'DashboardPanel',

    mixins: [ CustomKpiSorting, BrandMixin ],

    props:[
      'yearsList',
      'yearsbywave',
      'dashdata',
      'optionsdata',
      'isBmwMoto',
      'isUsedBike',
      'isBmwM',
      'isBmwi',
      'isUsedCar',
      'isGebrauchtwagen',
      'selectedBrand',
      'selection'
    ],

    components:{
      performanceItem,
      compareItem,
      processexcellencecolumn,
      customertreatmentcolumn,
      processexcellencecolumnnew,
      customertreatmentcolumnnew,
      WideNscItem,
      bmwmotorradprocessexcellencecolumn,
      bmwmotorradcustomertreatmentcolumn,
      bmwmotorradOnLineprocessexcellencecolumn,
      bmwmprocessexcellencecolumn,
      bmwmcustomertreatmentcolumn,
      bmwiprocessexcellencecolumn,
      gebrauchtwagencockpit
    },

    methods: {
      getBrand() {
        // If new 2019 Dashboard is visible
        if (!(this.isBmwMoto || this.isUsedBike) && !this.isBmwM && this.isYear(2019)) {
          var brands = '';
          this.selectedBrand.forEach(n => {
            if (n.includes('BMW') || n.includes('MINI') || n.includes('xEV') || n.includes('GKL')) {
              if (brands.length > 0) {
                brands = brands + ', ';
              }
              brands = brands + n.split('^')[1];
            }
          });
          return brands;
        } else if(!(this.isBmwMoto || this.isUsedBike) && !this.isBmwM && this.isYear(2018)) {
          var brands = '';
          this.selectedBrand.forEach(n => {
            if (n.includes('BMW') || n.includes('MINI') && !n.includes('PHEV')) {
              if (brands.length > 0) {
                brands = brands + ', ';
              }
              brands = brands + n.split('^')[1];
            }
          });
          return brands;
        }
      },

      MotoradOnlineSelected() {
        let retVal = false;

        // get Motorrad Online Survey Id
        let survey = undefined;
        if (this.optionsdata && this.optionsdata.Surveys && this.optionsdata.Surveys.length > 0) {
          survey = this.optionsdata.Surveys.find(obj => obj.label === 'BMW Motorrad Online' || obj.label === 'BMW Used Bike Online 2019');
        }

        if(survey != undefined && this.selection && this.selection.Surveys.includes(survey.id)) {
          retVal = true;
        }

        return retVal;
      },


      getDisclaimerText() {
        let fullText = this.$t('Webportal.DashboardBMW.RecommendSubtext');
        if(this.isYear(2018)){
          return '*' + fullText.replace('[BRANDNAME]', this.getBrand());
        }
        if(this.yearsList == '2018,2019'){
          return '*Results only 2019'
        }
          return '';
      },
      getKpiGroupByString: function (code) {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return _.find(this.dashdata.OverallByWave, (x) => x.KpiCode === code)
      },
       getKpiGroupByString: function (code) {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return _.find(this.dashdata.OverallByWave, (x) => x.KpiCode === code)
      },

      isYear(year) {
        let bysurvey = this.yearsList && this.yearsList.includes(year);
        let bywave =  this.yearsbywave && this.yearsbywave.includes(year);
        return bysurvey && (bywave || this.yearsbywave.length === 0);
      }
    },

    computed: {

      getKpiGroupOverall: function() {
        return this.getKpiGroupByString('00. Overall')
      },

      getKpiGroupOverallOrdered: function() {
        let item = this.getKpiGroupByString('00. Overall');
        return this.getOrderedKpi(item);
      },

      getKpiGroupOverallKpiName: function() {
        var item = this.getKpiGroupOverall;
        if (item) {
          return item.KpiName
        }
      },

      getOverallByWave: function() {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      isKpiGroupOverallVisible: function () {
        var _kpi = this.getKpiGroupOverall
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result =  _kpi.SurveyWave[0].ResultNSC
        return result  != undefined
      },

      hasDashdata: function () {
        return _.isEmpty(this.dashdata);
      }
    }
  }
</script>

<style scoped>


  .right {
    display: block;
    float: right;
    margin-right: 0%;
    font-size: 12px;
  }

  #headtext2 {
    height: 24pt;
    text-align: center;
    color: #111111;
    position: relative;
    top: -6px;
    display: inline-block;
    font-weight: 500;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  .header-container {
    width: 800px;
    padding-right: 0px;
    padding-left: 0px;
    height: 38px;
  }

  #customerjourney {
    width: 96%;
    height: 40px;
    position: relative;
    background: #91a2be;
    margin: 4px;
    text-align: center;
    color: white;
    font-size: 18pt;
  }

    #customerjourney:before {
      content: "";
      position: absolute;
      right: -40px;
      bottom: 0;
      width: 0;
      height: 0;
      border-left: 40px solid #91a2be;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }

  .inlined {
    display: inline-block;
  }

  .inlined2 {
    display: inline-block;
    margin-top: 0px;
    top: -5px;
  }

  .tdct {
    margin: 0px;
    padding: 0px;
    margin-right: 0px;
  }

  .dashtable {
    table-layout: fixed;
    width: 100%;
    white-space: nowrap;
    margin-inline-start: 1px;
    margin-block-start: -2px;
  }

    .dashtable td {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

  .row-pe {
    width: 83%;
    vertical-align: top;
  }

  .row-ct {
    width: 17%;
    vertical-align: top;
  }

  .col-xl-2 {
    padding-right: 0px;
    padding-left: 0px;
  }

  .col-xl-10 {
    padding-right: 0px;
    padding-left: 8px;
  }

  .perfItem {
    position: relative;
    float: left;
    width: 12pc;
    top: 1px;
  }

  .dp-header {
    width: 750px;
    padding-right: 0px;
    padding-left: 0px;
  }

  .card-header:first-child {
    border-radius: 0rem;
    margin: 0px;
    padding: 0px;
  }

  .card-header {
    background: #BFBFBF;
    height: 40px;
    margin: 0px;
    padding: 0px;
  }

  .card {
    border: solid #BFBFBF;
    border-width: 2px;
    border-radius: 0rem;
    margin-left: 0px;
  }

  .card-body {
    padding: 0px;
    margin-left: 0px;
    margin-top: 2px;
  }

  h3 {
    height: 36pt;
    line-height: 28pt;
    text-align: center;
    color: #111111;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  div.leftImage {
    position: absolute;
    left: 3px;
    top: 0px;
    bottom: 1px;
  }
</style>
